import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Table, Button, Card, Popconfirm, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import Layout from "../../ReusableComponents/Layout";
import getContactUs from "../../Redux/APIs/ContactusAPIs/get";
import deleteContactUs from "../../Redux/APIs/ContactusAPIs/delete";

const { Title, Text } = Typography;

const ContactUs = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  useEffect(() => {
    dispatch(getContactUs(setData));
  }, []);

  const filterContactsDeletion = (id) => {
    setData((prev) => prev.filter((d) => d._id !== id));
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      render: (text) => <span style={{ textTransform: "capitalize", fontWeight: 500 }}>{text}</span>,
    },
    { title: "Last Name", dataIndex: "lastName", key: "lastName" },
    { title: "Email", dataIndex: "email", key: "email", ellipsis: true },
    { title: "Subject", dataIndex: "subject", key: "subject" },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      ellipsis: true,
    },
    {
      title: "",
      key: "actions",
      width: 50,
      render: (_, record) => (
        <Popconfirm
          title="Are you sure you want to delete this contact?"
          onConfirm={() => dispatch(deleteContactUs(record._id, filterContactsDeletion))}
          okText="Yes"
          cancelText="No"
        >
          <Button type="text" danger icon={<DeleteOutlined />} style={{ borderRadius: 6 }} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <Layout>
      <Card
        style={{
          borderRadius: 12,
          boxShadow: "0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)",
        }}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            padding: "16px 24px",
            borderBottom: "1px solid #f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Title level={5} style={{ margin: 0 }}>Contact Submissions</Title>
          <Text type="secondary" style={{ fontSize: 13 }}>
            {data?.length ?? 0} records
          </Text>
        </div>

        <Table
          columns={columns}
          dataSource={data}
          rowKey="_id"
          pagination={false}
        />
      </Card>
    </Layout>
  );
};

export default ContactUs;
